import { render, staticRenderFns } from "./MockAccountData.vue?vue&type=template&id=7ddcb775&"
import script from "./MockAccountData.vue?vue&type=script&lang=js&"
export * from "./MockAccountData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports